import request from '../common/request'

// 用户表单
export const enquiry = (params) => request.post('/public/index/enquiry', params)

export const ApiCreateClue = (params) => request.post('crm/clue/api_create', params)
